import React, { useState } from 'react'
import BatchRecycle from '../BatchRecycle'

function SewingRepairHeader(props) {
    const { selectedBatchId, selectedAll, onResetSelected, listSewingRepair, onSelectAll, reset } = props
    const [openActions, setOpenActions] = useState(false)

    function _handleChangeCheckbox(e) {
        const { checked } = e.target
        onSelectAll(checked)
    }

    function toggleActions() {
        setOpenActions(!openActions)
    }

    return (
        <thead className={`thead-light SewingRepairHeader ${selectedBatchId.length > 0 ? 'Hidden' : ''}`}>
            <tr>
                <th className="BatchSelectedAll">
                    <input type="checkbox" checked={selectedAll} onChange={_handleChangeCheckbox} />
                    {
                        selectedBatchId.length > 0 &&
                        <div className="CustomSelect">
                            <button type="button" className="dropdown-toggle"
                                onClick={toggleActions}
                            >
                                Thao tác
                            </button>
                            <div className={`ListAction ${openActions ? 'Open' : ''}`}>
                                <div className="ContentActions">
                                    <BatchRecycle
                                        items={listSewingRepair}
                                        selectedBatchId={selectedBatchId}
                                        // getBatchesError={getBatchesError}
                                        onResetSelected={onResetSelected}
                                        reset={reset}
                                    />
                                </div>
                            </div>
                            <div className={`Background ${openActions ? 'Open' : ''}`} onClick={toggleActions} />
                        </div>
                    }
                </th>
                <th className='Barcode'>Barcode</th>
                <th className='Sku'>SKU</th>
                <th className='Size'>Size</th>
                <th className='CreatedDate'>Ngày báo lỗi</th>
                <th className='ErrorType'>Loại lỗi</th>
                <th className='OverTime'>Quá hạn</th>
                <th className='Partner'>Đối tác in ép</th>
                <th className='SewingPartner'>Đối tác may</th>
            </tr>
        </thead>
    )
}

export default SewingRepairHeader